/**
 * AssetBadgeSubscriber — REST baseline for the Asset Management sidebar badges.
 * Sets `myAssets` (count of assets the current user owns) on mount. There is no
 * asset dashboard hub, so this is a simple baseline (no SignalR deltas).
 */

import { useCallback, useEffect } from 'react';
import { useAssetService } from '@actschurch/ccms-sdk';
import { useEnrichedAuth } from '@/hooks/useEnrichedAuth';
import { useAssetBadgesStore } from './assetBadgesStore';

export function AssetBadgeSubscriber() {
  const { user } = useEnrichedAuth();
  const userId = user?.id;
  const service = useAssetService();
  const setFromMetrics = useAssetBadgesStore((s) => s.setFromMetrics);
  const reset = useAssetBadgesStore((s) => s.reset);

  const refetch = useCallback(async () => {
    if (!userId) return;
    try {
      const mine = await service.listView({ ownerUserId: userId });
      setFromMetrics({ myAssets: (mine ?? []).length });
    } catch {
      /* best-effort */
    }
  }, [userId, service, setFromMetrics]);

  useEffect(() => { void refetch(); }, [refetch]);
  useEffect(() => () => reset(), [reset]);

  return null;
}
